<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM月销售数据（W）"
      rightTitle="2022年 合计：9999"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="center_3" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "center_3",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_3"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        color: ["#009dff"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          left: "12%",
          top: "15%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
          ],
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260, 150, 230, 224, 218, 135],
            type: "line",
            areaStyle: { opacity: 0.3 },
            color: "#1c7ce8",
          },
          {
            // 设置涟漪特效动画
            type: "effectScatter",
            // 有三种: cartesian2d(二维的直角坐标系) polar(极坐标系) geo(地理坐标系) ,此需求使用cartesian2d
            coordinateSystem: "cartesian2d",
            // 单个闪烁点 ↓
            data: [{ value: ["七月", 260], symbolSize: 9 }], //2d坐标系--[x轴, y轴, 标记大小]

            // 多个闪烁点 ↓
            // 方法一 -- start:
            // data: [{value:['Mon',820],symbolSize:10},{value:['Tue',932],symbolSize:10}],
            // 方法一 -- end

            // 方法二 -- start:
            // data: [['Mon',820],['Tue',932]], //2d坐标系--[x轴, y轴, 标记大小]
            // symbolSize: 10,
            // 方法二 -- end

            // 何时显示特效:'render'-绘制完成后显示特效 'emphasis'-高亮（hover）的时候显示特效
            showEffectOn: "render",
            // 涟漪特效配置
            rippleEffect: {
              // 波纹的绘制方式,可选'stroke'和'fill'
              brushType: "stroke",
            },
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.9)",
                shadowBlur: 38,
                shadowColor: "rgba(255,255,255,0.9)",
              },
            },
            zlevel: 1,
          },
        ],
      });
    },
    //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 30vh;
  #center_3 {
    height: 100%;
  }
}
</style>
